<template>
	<div id="map-overlay" :class="[{ 'active': this.overlayActive }]">
		<div v-if="!this.showingEvent">
			<div class="overlay-content">
				<div class="col-left">
					<h2 v-if="this.overlayData.name">
						{{ this.overlayData.name }}
					</h2>
					<div v-if="this.activeEvent" class="todays-event" v-on:click="showEventCard">
						Today's Event
						<img alt="star icon" :src="starIcon">
					</div>
					<p v-if="this.overlayData.description">{{ this.overlayData.description }}</p>
				</div>
				<div class="col-right" v-if="overlayData.images && overlayData.images.length">
					<ImageCarousel :images="overlayData.images"></ImageCarousel>
				</div>
			</div>
			<div class="overlay-content" v-for="sub in this.overlayData.subcategories" :key="sub.name" :id="'_' + sub.name.replace(/[\s\/]/g, '')">
				<div class="col-left">
					<h2 v-if="sub.name">
						{{ sub.name }}
					</h2>
					<p v-if="sub.description">{{ sub.description }}</p>
				</div>
				<div class="col-right" v-if="sub.images && sub.images.length">
					<ImageCarousel :images="sub.images"></ImageCarousel>
				</div>
			</div>
		</div>
		<EventCard 
			ref="eventCard"
			v-if="this.activeEvent" 
			:eventData="activeEvent" 
			@hideCard="hideEventCard()">
		</EventCard>
	</div>
</template>

<script>
	import ImageCarousel from '@/components/ImageCarousel.vue';
	import EventCard from '@/components/EventCard.vue';
	import { gsap } from 'gsap';
	import { ScrollToPlugin } from 'gsap/all'

	export default {
		name: "MapContentOverlay",
		components: {
			ImageCarousel,
			EventCard
		},
		props: {
			
		},
		data: function() {
			return {
				sharedStore: window.store,
				overlayData: {},
				starIcon: require('../assets/ui/star-icon.svg'),
				showingEvent: false
			}
		},
		mounted: function() {
			gsap.registerPlugin(ScrollToPlugin);
		},
		watch: {
			"sharedStore.state.currentLocation": function() {
				if (this.sharedStore.state.currentLocation !== "" && this.sharedStore.state.subcategorySelection !== "") {
					// TODO: Handle subcategory selection in kiosk mode, when we are not in a single page scroll
					this.$nextTick(() => {

						let target = document.getElementById(this.sharedStore.state.subcategorySelection);
						if (target !== null) {
							gsap.set("#map-overlay", {
								scrollTo: {
									y: "#" + this.sharedStore.state.subcategorySelection
								}
							});	
						}

						this.sharedStore.setSubcategorySelection("");
					});
				}

				this.updateOverlayData();
			},
			"sharedStore.state.lastDataUpdate": function() {
				this.updateOverlayData();
			},
			"sharedStore.state.languageCode": function() {
				this.updateOverlayData();
			}
		},
		computed: {
			overlayActive: function() {
				return this.sharedStore.state.currentLocation.length > 0;
			},
			activeEvent: function() {
				const events = this.sharedStore.state.todaysEventsData.listItems;
				let activeEvent = null;
				if (events) {
					for (let i = 0; i < events.length; i++) {
						if (events[i].location) {
							const prefix = events[i].location.MapID;
							if (prefix == this.sharedStore.state.currentLocation) {
								activeEvent = events[i];
								break;
							}
						}
					}
				}
				return activeEvent;
			}
		},
		methods: {
			updateOverlayData: function() {
				let allData = this.sharedStore.state.locationData;
				let newData = allData.filter(obj => {
					return obj.code === this.sharedStore.state.currentLocation
				});
				let languageCode = this.sharedStore.state.languageCode;
				if (newData.length) {
					newData = newData[0];
					// apply localized strings and subcategories
					newData.name = newData["name_" + languageCode];
					newData.description = newData["description_" + languageCode];
					if (newData.subcategories.length) {
						// apply images from main subcategory to localized subcategory
						let localizedSub = newData["subcategories_" + languageCode];
						for (let i = 0; i < localizedSub.length; i++) {
							if (newData.subcategories[i]) {
								newData.subcategories[i].name = localizedSub[i].name;
								newData.subcategories[i].description = localizedSub[i].description;
							}
						}
					}
				} else {
					newData = {};
				}

				this.overlayData = newData;
			},
			showEventCard: function() {
				this.showingEvent = true;
				this.$refs.eventCard.showCard();
			},
			hideEventCard: function() {
				this.showingEvent = false;
			}, 
			triggerHide: function() {
				this.$refs.eventCard.hideCard();
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
	#map-overlay {
		position: absolute;
		bottom: 0;
		right: 0;
		height: 100%;
		width: 100%;
		background: rgb(25, 25, 25);
		opacity: 0;
		transform: translateY(100%);
		transition: 0.5s;
		overflow-y: auto;
		padding-bottom: 80px;
		pointer-events: none;

		&.active {
			opacity: 1;
			transform: translateY(0px);
			pointer-events: auto;
		}

		@media (min-aspect-ratio: 1/1) {
			width: 50%;
		}
	}

	.overlay-content {
		width: 100%;
		display: flex;
		flex-direction: column-reverse;
		justify-content: flex-end;
		color: #ffffff;
		text-align: left;
	}

	.col-left, .col-right {
		position: relative;
		width: 100%;
		
	}

	.col-left {
		padding: 20px 28px;
	}

	.col-right {
		height: 300px;
	}

	h2 {
		margin: 0;
	}

	p {
		margin: 10px 0;
		white-space: pre-wrap;
	}

	.kiosk {
		// styles for when we are in kiosk mode
		#map-overlay {
			height: 400px;
			background: #ffffff;
			transition: 0.5s;
		}

		.overlay-content {
			flex-direction: row;
			justify-content: flex-start;
			color: #000000;
		}

		.col-left, .col-right {
			width: 50%;
			height: 100%;
			padding: 10px;
		}
	}

  .todays-event {
    display: flex;

    img {
      width: 15px;
      margin-left: 10px;
    }
  }
</style>